import { surveyFormsService } from "../../../Api/Services/SurveyFormsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";
import { ERROR_MESSAGES } from "../../../constants/error";
import { ISubmitSurveyFormResponsePayload } from "../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";

export const submitSurveyFormResponse = createServiceAsyncThunk<
  { status: boolean; message: string },
  { form_id: number; user_id: number; payload: ISubmitSurveyFormResponsePayload }
>(
  ACTION_NAMES.SUBMIT_SURVEY_FORM_RESPONSE,
  ({ form_id, user_id, payload }) =>
    surveyFormsService.submitSurveyFormResponse(form_id, user_id, payload),
  ERROR_MESSAGES.SURVEY_FORM_RESPONSE_SUBMIT_FAILURE
);

const surveyFormResponseSubmitSlice = createGenericSlice<{ status: boolean; message: string }, any>(
  SLICE_NAMES.SURVEY_FORM_RESPONSE_SUBMIT_SLICE,
  submitSurveyFormResponse
);

export const {
  clearError: clearSurveyFormResponseSubmitError,
  clearSuccessMessage: clearSurveyFormResponseSubmitSuccessMessage
} = surveyFormResponseSubmitSlice.actions;

export default surveyFormResponseSubmitSlice.reducer;
